import moment from 'moment-timezone';

function createDateWrapper(dateValue) {
  const mDate = moment(dateValue);

  if (!mDate.isValid()) return null;

  return {
    date: mDate,
    toISOString() {
      return this.date.toISOString();
    },
    toLocalString() {
      return this.date.toDate().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },
  };
}

export function momentDate(date = null) {
  return createDateWrapper(date);
}

export function getInactivationDateCalc(
  periodicity,
  day,
  month,
  staticInactiveDate = false,
) {
  const date = moment();

  switch (periodicity) {
    case 'YEAR':
      date.add(1, 'year');

      if (month != null && staticInactiveDate) {
        date.month(month - 1);
      }

      if (day != null && staticInactiveDate) {
        date.date(Math.min(day, date.daysInMonth()));
      }
      break;

    case 'MONTH':
      date.add(1, 'month');

      if (day != null && staticInactiveDate) {
        date.date(Math.min(day, date.daysInMonth()));
      }
      break;

    case 'TRIMESTER':
      date.add(3, 'months');

      if (day != null && staticInactiveDate) {
        date.date(Math.min(day, date.daysInMonth()));
      }
      break;

    default:
      throw new Error(`Periodicidad inválida: ${periodicity}`);
  }

  return createDateWrapper(date);
}